import apiClient from '@u/apiClient'
import router from '@/router'

let baseErrors = []
export default {
  //region fetch
  async fetchImplantationIndex({ commit }) {
    commit('auth/setErrors', baseErrors, { root: true })
    await apiClient
      .get('api/implantation')
      .then(async (response) => {
        await commit('setImplantationList', response.data)
      })
      // Already toasted by apiClient.
      .catch(() => {})
  },
  async fetchImplantationByID({ commit }, payload) {
    commit('auth/setErrors', baseErrors, { root: true })
    await apiClient
      .get(`api/implantation/${payload.id}`)
      .then(async (response) => {
        await commit('setImplantation', response.data.implantation)
        await commit('setImplantationMetaData', response.data.metadata)
      })
      // Already toasted by apiClient.
      .catch(() => {})
  },
  async fetchNewImplantation({ commit }) {
    commit('auth/setErrors', baseErrors, { root: true })
    await apiClient
      .get('api/model/new?model=implantation')
      .then(async (response) => {
        await commit('setImplantation', response.data.implantation)
        await commit('setImplantationMetaData', response.data.metadata)
      })
      // Already toasted by apiClient.
      .catch(() => {})
  },
  //endregion

  //region store
  storeNewImplantation({ commit }, payload) {
    commit('auth/setErrors', baseErrors, { root: true })
    return apiClient
      .post('api/implantation', payload.implantation)
      .then((response) => {
        commit('auth/setErrors', baseErrors, { root: true })
        return response.data
      })
  },
  //endregion

  //region update
  updateImplantation({ commit }, payload) {
    commit('auth/setErrors', baseErrors, { root: true })
    return apiClient
      .put(`api/implantation/${payload.id}`, payload.implantation)
      .then((response) => {
        commit('auth/setErrors', baseErrors, { root: true })
        router.push({ name: 'settings_list_implantation' })
        return response.data
      })
  },
  //endregion

  //region delete
  deleteImplantationById({ commit }, payload) {
    commit('auth/setErrors', baseErrors, { root: true })
    return apiClient
      .delete(`api/implantation/${payload.id}`)
      .then(async (response) => {
        await commit('setImplantationList', response.data)
        return response.data
      })
  },
  //endregion

  //region undoDelete
  undoDeleteImplantationById({ commit }, payload) {
    commit('auth/setErrors', baseErrors, { root: true })
    return apiClient
      .get(`api/implantation/undo-delete/${payload.id}`)
      .then(async (response) => {
        await commit('setImplantationList', response.data)
        return response.data
      })
  }
  //endregion
}
